
<f-dialog
    v-model       = "show"
    :width        = "950"
    :show-header  = "false"
    :hide-actions = "false"
    :inset        = "false"
    content-class = "dialog-border"
    :store-label  = "$t('dms.combine.label')"
    @store        = "onCombine"
    @cancel       = "onCancel"
>
    <template v-slot:content>
        <div v-if="steps && documents" style="height: 600px">
            <div class="doc-target v-flex pa-4 pt-3">
                <div class="pr-1 w-50" >
                    <v-select
                        :label         = "$t('dms.combine.targetstep')"
                        v-model        = "target.step"
                        :items         = "steps"
                        item-value     = "id"
                        item-text      = "name"
                        :return-object = true
                    >
                    </v-select>
                </div>
                <div class="pl-1 w-50">
                    <v-text-field
                        :label  = "$t('dms.combine.targetfile')"
                        v-model = "target.filename"
                    />
                </div>

            </div>
            <div class="v-flex" style="height: calc(100% - 65px)">
                <div class="ml-4 mr-1 mt-4 w-50" style="overflow-y: scroll">
                    <div
                        v-for = "(step,index) in steps"
                        :key  = "'step-' + index"
                        class = "lm-border mb-3 mr-1"
                    >
                        <div class="doc-step-header primary-background white--text pr-1">
                            {{ step.name }}
                        </div>
                        <div class="mt-0 mb-4 doc-step-scroll mr-1">
                            <div
                                class="doc-step-document v-flex"
                                v-for="(document, index) in getStepDocuments (step)"
                                :key = "'doc-' + index"
                            >
                                <div style="margin-top: 20px;">
                                    <v-checkbox
                                        class="pt-0 mt-0"
                                        v-model = "document.selected"
                                        :ripple = "false"
                                        hide-details
                                        @change = "onSelected"
                                    />
                                </div>
                                <div class="pt-1 w-100">
                                    <p-dms-entry-card
                                        class="lm-border mr-1"
                                        :document = document
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ml-4 mr-3 mt-4 mb-2 w-50 h-100">
                    <div class="doc-step-header primary-background white--text pr-1" style="width: calc(100% - 10px)">
                        Reihenfolge
                    </div>
                    <div class="pr-1 pt-0 mt-0 " style="border-top-left-radius: 0!important; border-top-right-radius: 0!important;">
                        <v-container fluid class="wrapper  doc-result-scroll pt-2 pr-1 mt-2" style="padding: 0!important;">
                            <drop-list
                                :items="selected"
                                class="list"
                                @reorder="$event.apply(selected)"
                            >
                                <template v-slot:item="{item}">
                                    <drag class="item lm-border mb-1 mr-1" :key="item.id">
                                        <p-dms-entry-card
                                            :document = "item"
                                        />
                                    </drag>
                                </template>
                            </drop-list>
                        </v-container>
                    </div>
                </div>
            </div>
        </div>
    </template>
</f-dialog>
